import Frame from "../common/Frame";
import Footer from "../common/Footer";
import {useTranslation} from "react-i18next";
import React from "react";
import {useHistory} from "react-router-dom";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {registerConcersion} from "../../logic/funel/FacebookUtils";


export function Unsubscribe() {
    const history = useHistory();
    const {t} = useTranslation();
    // @ts-ignore
    function confirm1() {
        appdata.utm_brand = "UnsubscribeConfirm"
        registerConcersion('UnsubscribeConfirm');
        appdata.messageKey = "YouHaveSuccessFyllyUnsubscribed"
        history.push("/genericMessage");
    }
    return (
        <div>
            <Frame>
                <h2 className="offer-pay__title">
                    {t("PleaseConfirmUnsubscribtion")}
                </h2>
                <div className="app-button d-flex justify-content-around">
                    <button id = "next" type="submit" className="app-btn app-btn-further next-step-btn" onClick={()=>confirm1()}>
                        {t("ConfirmUnsubscriptions")}
                    </button>
                </div>
                <Footer></Footer>
            </Frame>
        </div>
    );
}
